/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
window.Vue = Vue;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

$(document).on('click', '.fc-button', function(){
    if($(".fc-dayGridMonth-button").hasClass("fc-button-active")) {
        changeView("monthly");
    } else if($(".fc-dayGridWeek-button").hasClass("fc-button-active")) {
        changeView("calendar");
    } else {
        changeView("list");
    }
});

function changeView(view) {
    $(".download-url").each(function() {
        let current = $(this).attr("href");
        if(current) {
            let url     = current.replace(/(view=).*?(&)/,'$1' + view + '$2');
            $(this).attr("href", url);
        }
    });
}

$(document).ready(function () {
    $('#view').on('input', function() {
        let view = $("#view").val();
        $(".download-url").each(function() {
            let current = $(this).attr("href");
            let url     = current.replace(/(view=).*?(&)/,'$1' + view + '$2');
            $(this).attr("href", url);
        });
    });
    $('#period').on('input', function() {
        let period = $("#period").val();
        $(".download-url").each(function() {
            let current = $(this).attr("href");
            let url     = current.replace(/(period=).*?(&)/,'$1' + period + '$2');
            $(this).attr("href", url);
        });
    });
});
$(".custom-file-input").on("change",function(){
    let fileName = $(this).val();
    $(this).next(".custom-file-label").html(fileName.replace("C:\\fakepath\\",""));
});

$("form").submit(function() {
    let element = $("button[type=submit]:not(.prop-enable)");
    let width   = element.width();
    $(element).width(width).prop("disabled", true).html('<div class="spinner-grow spinner-grow-sm" role="status"><span class="sr-only">Loading...</span></div>');
    let target = $(this).data("target");
    $(this).attr("action",target).submit();
});
